export default __webpack_public_path__ + "static/media/photo--lg--misc-7.edfd810c.jpg";